import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as trialLicensesService from '../services/trialLicenses';
import { entitiesAdapter } from './common/adapter';

const initialState = {
  isFetching: false,
  fetchingError: null
};

const sliceName = 'trialLicenses';

export const fetchAll = createAsyncThunk(
  `${sliceName}/fetchAll`,
  (args, thunkAPI) => {
    return trialLicensesService.getTrialLicenses()
      .catch((error) => {
        error.clientMessage = "Can't get trial licenses from server";
        return thunkAPI.rejectWithValue(error)
      });
  }
);

const trialLicenses = createSlice({
  name: sliceName,
  initialState: entitiesAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: {
    [fetchAll.fulfilled]: (state, action) => {
      console.log(action)
      state.isFetching = false;
      entitiesAdapter.setAll(state, action);
    },

    [fetchAll.pending]: (state) => {
      state.isFetching = true;
      state.fetchingError = null;
    },

    [fetchAll.rejected]: (state, action) => {
      state.isFetching = false;
      state.fetchingError = action.payload;
    },
  }
});

const { reducer } = trialLicenses;

const trialLicensesAdapterSelectors = entitiesAdapter.getSelectors((state) => state[sliceName]);

export const trialLicensesSelectors = {
  ...trialLicensesAdapterSelectors,
  isFetching: ((state) => state[sliceName].isFetching),
  fetchingError: ((state) => state[sliceName].fetchingError),
};


export default reducer;



// WEBPACK FOOTER //
// ./src/store/trialLicensesSlice.js